import styled from "styled-components";
import { ColorsInterface } from "@/theme/colors";

interface LabelProps extends ColorsInterface {
  fontSize?: number;
}

/**
 * Label Component
 */

export const Label = styled.label<LabelProps>`
  ${({ color = "black", theme, fontSize = 16 }) => `
  color: ${theme.Colors[color]};
  font-family: ${theme.Fonts.ttNormsProBold};
  font-size: ${fontSize}px;
  line-height: 24px;
  `}
`;
